import '../styles/app.scss';
import '@babel/polyfill';
import Store from './data/store';
import TranslatedContent from './data/translatedContent';
import { StepIndicator } from './components/stepIndicator';
import { PackageConfigurationStep } from './components/wizardSteps/packageConfigurationStep';
import { WizardSteps } from './components/wizardSteps/wizardSteps';
import { StepNavigation } from './components/stepNavigation';
import { Receipt } from './components/receipt';
import { ContactInformationStep } from './components/wizardSteps/contactInformationStep';
import { PersonalInformationStep } from './components/wizardSteps/personalInformationStep';
import { PasswordStep } from './components/wizardSteps/passwordStep';
import { CompanyInformationStep } from './components/wizardSteps/companyInformationStep';
import { PaymentStep } from './components/wizardSteps/paymentStep';
import { ThankYouStep } from './components/wizardSteps/thankYouStep';
import { Support } from './components/support';

// eslint-disable-next-line no-unused-vars
const rootStore = new Store();
const store = Store.getStore();
const translatedContent = new TranslatedContent();
const translations = translatedContent.getTranslations();

// Create all necessary component wizard shell and navigation.
const wizardStepsElem = new WizardSteps({ store, translations });
const stepIndicatorElem = new StepIndicator({ store, translations });
const stepNavigationElem = new StepNavigation({
    store,
    translations,
    $context: document.getElementById('wizardNavigation'),
    wizardSteps: wizardStepsElem
});

wizardStepsElem.update();

const $stepIndicator = document.getElementById('stepIndicator');
const $stepNavigation = document.getElementById('wizardNavigation');

if ($stepIndicator) $stepIndicator.appendChild(stepIndicatorElem.render());

const receiptElem = new Receipt({ store, translations });
const supportElem = new Support({ store, translations });
supportElem.render();

// Create all necessary component instances for wizard steps.
const packageConfigurationStep = new PackageConfigurationStep({ store, translations });
const contactInformationStep = new ContactInformationStep({ store, translations, id: 'step_2' });
const personalInformationStep = new PersonalInformationStep({ store, translations, id: 'step_3' });
const passwordStep = new PasswordStep({ store, translations, id: 'step_4' });
const companyInformationStep = new CompanyInformationStep({ store, translations, id: 'step_5' });

const paymentStep = new PaymentStep({ store, translations, id: 'step_6' });
const thankYouStep = new ThankYouStep({ store, translations, id: 'step_7' });

// Gather all wizard DOM elements
const $packageConfigurationStep = document.getElementById('step_1_mainPanel');
const $contactInformationStep = document.getElementById('step_2_mainPanel');
const $personalInformationStep = document.getElementById('step_3_mainPanel');
const $passwordStep = document.getElementById('step_4_mainPanel');
const $companyInformationStep = document.getElementById('step_5_mainPanel');
const $paymentStep = document.getElementById('step_6_mainPanel');
const $thankYouStep = document.getElementById('step_7_mainPanel');
const $receipt = document.getElementById('receipt');

$stepNavigation.appendChild(stepNavigationElem.render())
$packageConfigurationStep.appendChild(packageConfigurationStep.render());
$contactInformationStep.appendChild(contactInformationStep.render());
$personalInformationStep.appendChild(personalInformationStep.render());
$passwordStep.appendChild(passwordStep.render());
$companyInformationStep.appendChild(companyInformationStep.render());
$paymentStep.appendChild(paymentStep.render());
$thankYouStep.appendChild(thankYouStep.render());

if($receipt) {
    $receipt.appendChild(receiptElem.render());
}
